import BrandingTemplate from "../../../templates/admin/branding";

const BrandingScreen = () => {
  return <BrandingTemplate />;
};

export default BrandingScreen;
